import React, { useState, useEffect } from "react";

import { Card, CardBody, Col, Row } from "reactstrap";

import avatar1 from "../../assets/images/users/luca.jpeg";
import profileImg from "../../assets/images/profile-img.png";
import { useSelector, useDispatch } from "react-redux";
import { getLoggedInUser } from "../../store/auth/login/actions";
const WelcomeComp = () => {
  const user = useSelector((state) => state?.Login?.user);
  const dispastch = useDispatch();
  useEffect(() => {
    dispastch(getLoggedInUser());
  }, []);
  console.log(user);
  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Welcome Back {user?.firstName}!</h5>
                <p>WeShoot Dashboard</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img
                  src={avatar1}
                  alt=""
                  className="img-thumbnail rounded-circle"
                />
              </div>
              <h5 className="font-size-15 text-truncate">{`${user?.firstName} ${user?.lastName}`}</h5>
              <p className="text-muted mb-0 text-truncate">Founder</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">125</h5>
                    <p className="text-muted mb-0">Projects</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">$1245</h5>
                    <p className="text-muted mb-0">Revenue</p>
                  </Col>
                </Row>
                <div className="mt-4"></div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default WelcomeComp;
